(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Moneda', Moneda);

    Moneda.$inject = ['$resource'];

    function Moneda ($resource) {
        var resourceUrl =  'api/monedas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
